import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3215a6bb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "complaint-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "complaint-hint --van-doc-text-color-1"
}, [/*#__PURE__*/_createTextVNode(" 我们是二维码在线服务平台，所有二维码内容由我们平台的用户自行制作。 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 如果二维码包含违法违规内容，我们将在核实后对该违规二维码进行封停，限制访问等操作。 ")], -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "complaint-select"
}, " 请选择投诉内容 ", -1));
import { onMounted } from "vue";
import { useRoute } from "vue-router";
export default {
  __name: 'ComplaintComponents',
  setup(__props) {
    const route = useRoute();
    const complaintId = route.query.complaintId;
    console.log('id===', complaintId);
    onMounted(() => {
      document.title = '内容投诉';
    });
    const list = [{
      title: '商品问题',
      subtitle: '质量问题、假货等',
      link: 'good'
    }, {
      title: '有害信息',
      subtitle: '政治敏感、色情、暴力恐怖、非法博彩、违禁品等',
      link: 'harmful'
    }, {
      title: '网络诈骗',
      subtitle: '网赚、钓鱼网站、伪造淘宝客服等网络诈骗行为',
      link: 'scam'
    }, {
      title: '伪造证书',
      subtitle: '伪造学历、发票、检疫证书、社保证明、商品防伪信息等',
      link: 'forgery'
    }, {
      title: '侵权',
      subtitle: '个人/企业等民事主体被诽谤侮辱、被侵犯人身权或知识产权',
      link: 'infringement'
    }, {
      title: '其他',
      link: 'other'
    }];
    return (_ctx, _cache) => {
      const _component_van_cell = _resolveComponent("van-cell");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _hoisted_3, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, item => {
        return _createVNode(_component_van_cell, {
          key: item,
          title: item.title,
          label: item.subtitle,
          "is-link": "",
          to: {
            name: item.link,
            params: {
              complaintId: _unref(complaintId)
            }
          }
        }, null, 8, ["title", "label", "to"]);
      }), 64))]);
    };
  }
};